import * as React from "react";
import { createPortal } from "react-dom";

/**
 * 자식을 `document.body` 에 그린다 — Radix 대화상자 밖에서도 쓸 수 있는 가장 단순한 포털.
 *
 * 가운데 정렬(transform)된 대화상자 안에서 `position: fixed` 덮개를 그리면 화면이 아니라
 * 그 대화상자 기준으로 갇힌다. 화면 전체 덮개(파일 미리보기 등)는 이 포털로 뺀다.
 * React 트리는 그대로라 바깥 대화상자는 이 안의 클릭을 «안쪽» 으로 본다.
 * 서버 렌더링(문서 없음)에서는 자식을 제자리에 그린다.
 */
export function BodyPortal({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  if (typeof document === "undefined") return <>{children}</>;
  return createPortal(children, document.body);
}
